module.exports = __webpack_public_path__ + "img/WePark Logo-01.d9ffbe7f.png";